"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var SearchResultItem_1 = __importDefault(require("./SearchResultItem"));

var frontend_expansion_1 = require("@ryerson/frontend.expansion");

var frontend_application_1 = require("@ryerson/frontend.application");

var SearchResultItemContent_1 = require("./SearchResultItemContent");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var util_1 = require("../common/util");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var NotificationsContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\twidth: 100%;\n\ttop: 0;\n\toverflow: hidden;\n\tz-index: 99;\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n"])));
var ResultsWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\tz-index: 99;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
var ResultsAccordionWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tpadding: 20px;\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
var moreProductsButtonWrapper = (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tmargin-bottom: 24px;\n\tmargin-top: 24px;\n"])));

var SearchResultsMobile = function SearchResultsMobile(_ref) {
  var matchingProducts = _ref.matchingProducts,
      articlesResources = _ref.articlesResources,
      storeDirectory = _ref.storeDirectory,
      _ref$recentlyPurchase = _ref.recentlyPurchased,
      recentlyPurchased = _ref$recentlyPurchase === void 0 ? [] : _ref$recentlyPurchase,
      onMoreProducts = _ref.onMoreProducts,
      deliveryTimes = _ref.deliveryTimes,
      setDeliveryTimes = _ref.setDeliveryTimes,
      stateMessenger = _ref.stateMessenger,
      megaMenuProducts = _ref.megaMenuProducts,
      setTriggerDeliveryTimes = _ref.setTriggerDeliveryTimes;

  var _a;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var lighterGray = theme.colors.primary.lighterGray;

  var _ref3 = (0, frontend_application_1.useNotifications)(),
      notifications = _ref3.notifications;

  var _ref4 = (0, frontend_application_1.useApplication)(),
      isLoggedIn = _ref4.user.isLoggedIn,
      language = _ref4.localization.language;

  var hasRecentlyPurchasedItems = isLoggedIn && recentlyPurchased.length > 0;
  var MAX_ARTICLES = 3;

  var renderResults = function renderResults(items, sliceSize) {
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [items === null || items === void 0 ? void 0 : items.slice(0, sliceSize).map(function (item) {
        return (0, jsx_runtime_1.jsx)(SearchResultItem_1.default, {
          isMobile: true,
          item: item,
          storeDirectory: storeDirectory,
          deliveryTimes: deliveryTimes,
          setDeliveryTimes: setDeliveryTimes,
          setTriggerDeliveryTimes: setTriggerDeliveryTimes,
          stateMessenger: stateMessenger
        }, item.id);
      }), items.length > 2 && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "center",
        alignItems: "center",
        style: moreProductsButtonWrapper,
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          size: "xs",
          variant: "outline",
          shape: "rounded",
          label: SearchResultItemContent_1.SearchResultItemContent[language].moreProducts,
          paddingType: "relaxed",
          onClick: onMoreProducts
        })
      })]
    });
  };

  var renderArticles = function renderArticles() {
    var _a;

    return (_a = articlesResources === null || articlesResources === void 0 ? void 0 : articlesResources.filter(function (element, index) {
      return index < MAX_ARTICLES;
    })) === null || _a === void 0 ? void 0 : _a.map(function (_ref5, index) {
      var title = _ref5.title,
          link = _ref5.link;
      return (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        gatsby: (0, util_1.isGatsbyLink)(false, storeDirectory),
        to: link,
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: (0, react_1.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding: 8px 0px;\n\t\t\t\t\t\t"]))),
          children: (0, jsx_runtime_1.jsx)("span", {
            css: {
              fontSize: "12px"
            },
            children: title
          })
        })
      }, "article-".concat(index));
    });
  };

  var renderCategories = function renderCategories() {
    return megaMenuProducts === null || megaMenuProducts === void 0 ? void 0 : megaMenuProducts.map(function (_ref6, index) {
      var linkUrl = _ref6.linkUrl,
          megaMenuLinkLabel = _ref6.megaMenuLinkLabel,
          productCategoryLabel = _ref6.productCategoryLabel;
      return (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        gatsby: false,
        to: linkUrl,
        children: (0, jsx_runtime_1.jsx)("span", {
          css: {
            fontSize: "12px"
          },
          children: "".concat(productCategoryLabel, " ").concat(megaMenuLinkLabel).toUpperCase()
        })
      }, index);
    });
  };

  var renderNoResultsFound = function renderNoResultsFound() {
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "center",
        css: {
          height: "150px"
        },
        children: (0, jsx_runtime_1.jsx)(frontend_notification_1.Alert, {
          severity: "warn",
          size: "sm",
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            type: "primary",
            size: "sm",
            children: SearchResultItemContent_1.SearchResultItemContent[language].noResults
          })
        })
      })
    });
  };

  return (0, jsx_runtime_1.jsxs)(ResultsWrapper, {
    bgColor: lighterGray,
    children: [(notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (notification) {
      return notification.type === frontend_application_1.NotificationsType.AddToCart;
    }).length) > 0 && (0, jsx_runtime_1.jsx)(NotificationsContainer, {
      children: (_a = notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (notification) {
        return notification.type === frontend_application_1.NotificationsType.AddToCart;
      }).pop()) === null || _a === void 0 ? void 0 : _a.message
    }), (0, jsx_runtime_1.jsx)(ResultsAccordionWrapper, {
      direction: "column",
      className: "accordion-search",
      bgColor: lighterGray,
      children: hasRecentlyPurchasedItems ? (0, jsx_runtime_1.jsxs)(frontend_expansion_1.Accordion, {
        variant: "line",
        multiple: true,
        children: [(0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
          header: SearchResultItemContent_1.SearchResultItemContent[language].recentlyPurchasedProducts,
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: renderResults(recentlyPurchased, 3)
        }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
          header: SearchResultItemContent_1.SearchResultItemContent[language].otherProducts,
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: renderResults(matchingProducts, 2)
        }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
          header: SearchResultItemContent_1.SearchResultItemContent[language].productCategories,
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: renderCategories()
        }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
          header: SearchResultItemContent_1.SearchResultItemContent[language].articlesResources,
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: renderArticles()
        })]
      }) : (0, jsx_runtime_1.jsxs)(frontend_expansion_1.Accordion, {
        variant: "line",
        multiple: true,
        children: [(0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
          header: SearchResultItemContent_1.SearchResultItemContent[language].matchingProducts,
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: matchingProducts.length ? renderResults(matchingProducts, 3) : renderNoResultsFound()
        }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
          header: SearchResultItemContent_1.SearchResultItemContent[language].productCategories,
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: renderArticles()
        })]
      })
    })]
  });
};

exports.default = SearchResultsMobile;